import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { KindredMark } from "./KindredMark";

const FOUNDING_PAYPAL_URL = "https://www.paypal.com/ncp/payment/KYERFXL4ZYLL8";

export const Navbar = () => {
  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-[#C4A36A]/25 bg-[#F7F3EA]"
      data-testid="navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6 sm:py-4 md:px-12">
        <a href="#top" className="flex min-w-0 items-center gap-2" data-testid="nav-logo">
          <KindredMark className="h-7 w-7 shrink-0" />
          <span className="truncate font-serif text-base font-semibold tracking-tight text-[#9A7428] sm:text-xl">Community Hearts</span>
        </a>
        <div className="flex shrink-0 items-center gap-3 sm:gap-6">
          <Link
            to="/pricing"
            data-testid="nav-pricing-link"
            className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#9A7428] transition-colors duration-300 hover:text-[#7A5A14] sm:text-xs"
          >
            Pricing
          </Link>
          <Link
            to="/beta"
            data-testid="nav-beta-link"
            className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#9A7428] transition-colors duration-300 hover:text-[#7A5A14] sm:text-xs"
          >
            Beta
          </Link>
          <a
            href={FOUNDING_PAYPAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-join-waitlist-button"
            className="btn-glow rounded-full bg-gold px-3.5 py-2 text-[10px] font-bold uppercase tracking-[0.12em] text-ink hover:bg-gold-deep active:scale-95 sm:px-6 sm:py-2.5 sm:text-xs sm:tracking-[0.15em]"
          >
            <span className="sm:hidden">Founding</span>
            <span className="hidden sm:inline">Founding member — Richmond</span>
          </a>
        </div>
      </div>
    </motion.header>
  );
};
